"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var ComponenticInterLoop = function ComponenticInterLoop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    color: props.color
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    fillRule: "evenodd",
    d: "M5.518 10.083C5.14 6.673 8.09 4 11.182 4c3.843 0 6.844 3.297 6.844 7.222 0 .658-.069 1.301-.2 1.921C19.67 11.811 21 9.643 21 6.723a1 1 0 1 1 2 0c0 4.795-2.915 7.978-6.322 9.29C15.204 18.398 12.658 20 9.718 20 7.2 20 5.09 19.036 3.57 17.366c-1.506-1.655-2.378-3.942-2.568-6.533a1 1 0 1 1 1.994-.147c.166 2.245.91 4.077 2.053 5.334C6.18 17.262 7.749 18 9.718 18a6.01 6.01 0 0 0 3.73-1.315c-1.637.064-3.263-.29-4.631-1.124-1.772-1.082-3.026-2.925-3.3-5.478Zm9.79 4.284a7.137 7.137 0 0 0 .718-3.145C16.026 8.28 13.803 6 11.182 6c-2.08 0-3.904 1.81-3.676 3.865v.004c.21 1.959 1.132 3.239 2.353 3.985 1.252.764 2.9 1.015 4.583.716.29-.052.58-.12.866-.203Z",
    clipRule: "evenodd"
  }));
};
ComponenticInterLoop.defaultProps = {
  color: "#161616"
};
var _default = ComponenticInterLoop;
exports["default"] = _default;